export function getFishProductUrl(backendUrl, scientificName, size, url) {
  return `${backendUrl}/listings/${scientificName}/size/${size}/redirect?url=${encodeURIComponent(url)}`;
}
